import { onReady } from "../../utils/events/onReady";
import { addEvent } from "../../utils/events/events";
import Cookies from "js-cookie";
export class Iframe {
    data = {};
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} container - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;

        onReady(() => this.init(this.dom.container));
    }

    checkCookies() {
        // Creating and example obj  to set cookies
        // const cookieExample = `{"website_uuid":"7f9612c5-e796-4953-ad10-4f075a0e6943","timestamp":"2022-09-18T13:34:41.164Z","consent_url":"https://prod-andelskassen-dk.azurewebsites.net/privat/kundeprogram/","consent_website":"andelskassen.dk","consent_domain":"prod-andelskassen-dk.azurewebsites.net","user_uid":"ffece4db-3e2b-48eb-9652-df5a6c24010f","consents_approved":["cookie_cat_necessary"],"consents_denied":["cookie_cat_functional","cookie_cat_statistic","cookie_cat_marketing","cookie_cat_unclassified"],"user_agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/105.0.0.0 Safari/537.36"}`
        // Cookies.set("CookieInformationConsent", cookieExample)
        let cookies = Cookies.get();
        if (
            cookies.CookieInformationConsent &&
            JSON.parse(cookies.CookieInformationConsent).consents_denied
                .length === 0
        ) {
            const cookieMessage =
                this.dom.container.querySelector(".cookies--message");
            cookieMessage.classList.add("cookies--hidden");
            return;
        }
    }

    init() {
        this.checkCookies();
        const decline = document.querySelector("button.coi-banner__decline");
        const accept = document.querySelector("button.coi-banner__accept");
        if (decline && accept) {
            addEvent(decline, "click", () => {
                this.checkCookies();
            });
            addEvent(accept, "click", () => {
                this.checkCookies();
            });
        }
    }
}
